import React from "react";
import { FileText, Download } from "lucide-react";
import PageHeader from "@/components/layout/PageHeader";
import GlassCard from "@/components/ui-fleet/GlassCard";

const REPORTS = [
  { name: "Monthly Fleet Performance — Jan 2026", type: "PDF", size: "2.4 MB", date: "2026-02-01" },
  { name: "Service SLA Audit — Q4 2025", type: "PDF", size: "1.1 MB", date: "2026-01-15" },
  { name: "Fuel Anomaly Report — Site B Pune", type: "XLSX", size: "320 KB", date: "2026-02-05" },
  { name: "Dealer Performance — North Region", type: "PDF", size: "880 KB", date: "2026-01-28" },
  { name: "AI Predictive Maintenance Log", type: "CSV", size: "640 KB", date: "2026-02-04" },
];

export default function Reports() {
  return (
    <div data-testid="reports-page">
      <PageHeader title="Reports" breadcrumb="Tools" />
      <GlassCard className="p-5">
        <div className="space-y-2">
          {REPORTS.map((r, i) => (
            <div key={i} className="glass-card-sm p-4 flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ background: "var(--accent-dim)", color: "var(--accent)" }}>
                <FileText size={18} />
              </div>
              <div className="flex-1">
                <div className="text-[14px] font-medium" style={{ color: "var(--slate-900)" }}>{r.name}</div>
                <div className="text-[11px] mt-0.5" style={{ color: "var(--slate-500)" }}>
                  <span className="font-mono">{r.type}</span> · {r.size} · Generated {r.date}
                </div>
              </div>
              <button className="btn-ghost flex items-center gap-1.5"><Download size={12} /> Download</button>
            </div>
          ))}
        </div>
      </GlassCard>
    </div>
  );
}
